import React, { useContext, useMemo } from 'react';
import { GPC_APPROACH_TYPE } from 'common/constants/calibration';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import { ValuationInfo, ValuationsApproach } from 'common/types/valuation';
import { CustomSelect } from 'components';
import CalibrationContext from 'context/CalibrationContext';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import useHandleChangeApproach from './useHandleChangeApproach';

interface ApproachesListProps {
  cell: ICell;
  [key: string]: any;
}

const ApproachesList = ({ cell, ...restProps }: ApproachesListProps) => {
  const { onCommit, onRevert } = restProps;
  const {
    calibration,
    approaches,
    calibrationPerformanceSheet,
    calibrationOutputSheet,
    company,
    customClasses,
    financialStatementsList,
  } = useContext(CalibrationContext) as any;
  const [globalStore] = useStore() as unknown as UseStoreValues;
  const { valuationInfo } = globalStore;
  const valuationsApproaches = useMemo(() => {
    const { valuations_approaches: valuationsApproaches } = valuationInfo as ValuationInfo;
    return valuationsApproaches as ValuationsApproach[];
  }, [valuationInfo]);

  const { handleChange } = useHandleChangeApproach({
    cell,
    calibration,
    approaches,
    calibrationPerformanceSheet,
    calibrationOutputSheet,
    company,
    customClasses,
    financialStatementsList,
  });

  const getOptions = useMemo(() => {
    const tmpOptions: { value: string; label: string }[] = [];
    if (Array.isArray(valuationsApproaches)) {
      valuationsApproaches
        .filter(option => option.approach_type === GPC_APPROACH_TYPE)
        .forEach(option => {
          const value = option.id ?? option.panelId!;
          tmpOptions.push({
            value: value.toString(),
            label: option.name!,
          });
        });
    }

    return tmpOptions;
  }, [valuationsApproaches]);

  return (
    <CustomSelect
      id={`approaches-list-${cell.key}`}
      value={cell.value as string}
      options={getOptions}
      onChange={handleChange}
      onCommit={onCommit}
      onRevert={onRevert}
      onEmptyValue="SELECT-APPROACH"
      disabled={cell.readOnly}
    />
  );
};

export default ApproachesList;
